/**
 * Branded maintenance / configuration-error screen.
 * Shown when critical backend configuration is missing.
 */
export function MaintenanceScreen() {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background px-6 text-center">
      {/* Logo */}
      <div className="mb-8">
        <svg
          className="w-20 h-20 mx-auto"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="32" cy="32" r="28" className="fill-primary/15" />
          <circle cx="32" cy="32" r="20" className="fill-primary/30" />
          <path
            d="M24 32L30 38L40 26"
            className="stroke-primary"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <h1 className="text-2xl font-display font-bold text-foreground mb-3">
        Even geduld…
      </h1>
      <p className="text-muted-foreground max-w-sm leading-relaxed">
        Er ging iets mis, maar we zijn ermee bezig.
        <br />
        Probeer het later opnieuw.
      </p>

      <button
        onClick={() => window.location.reload()}
        className="mt-8 px-6 py-2.5 rounded-lg bg-primary text-primary-foreground font-medium text-sm hover:bg-primary/90 transition-colors"
      >
        Opnieuw proberen
      </button>
    </div>
  );
}
